export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/builds/big-dig-data/counter-validator/frontend/src/pages/index.vue'),
    /* no children */
    meta: {
      "requiresAuth": false,
      "layout": "public"
    }
  },
  {
    path: '/:path(.*)',
    name: '/[...path]',
    component: () => import('/builds/big-dig-data/counter-validator/frontend/src/pages/[...path].vue'),
    /* no children */
  },
  {
    path: '/about',
    name: '/about',
    component: () => import('/builds/big-dig-data/counter-validator/frontend/src/pages/about.vue'),
    /* no children */
    meta: {
      "requiresAuth": false
    }
  },
  {
    path: '/accept-invitation',
    name: '/accept-invitation',
    component: () => import('/builds/big-dig-data/counter-validator/frontend/src/pages/accept-invitation.vue'),
    /* no children */
    meta: {
      "requiresAuth": false,
      "layout": "public"
    }
  },
  {
    path: '/admin',
    /* internal name: '/admin' */
    /* no component */
    children: [
      {
        path: 'users',
        name: '/admin/users',
        component: () => import('/builds/big-dig-data/counter-validator/frontend/src/pages/admin/users.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/changelog',
    name: '/changelog',
    component: () => import('/builds/big-dig-data/counter-validator/frontend/src/pages/changelog.vue'),
    /* no children */
    meta: {
      "requiresAuth": false,
      "layout": "public"
    }
  },
  {
    path: '/history',
    name: '/history',
    component: () => import('/builds/big-dig-data/counter-validator/frontend/src/pages/history.vue'),
    /* no children */
  },
  {
    path: '/login',
    name: '/login',
    component: () => import('/builds/big-dig-data/counter-validator/frontend/src/pages/login.vue'),
    /* no children */
    meta: {
      "requiresAuth": false,
      "layout": "public"
    }
  },
  {
    path: '/monitoring',
    name: '/monitoring',
    component: () => import('/builds/big-dig-data/counter-validator/frontend/src/pages/monitoring.vue'),
    /* no children */
  },
  {
    path: '/public',
    /* internal name: '/public' */
    /* no component */
    children: [
      {
        path: ':public_id',
        name: '/public/[public_id]',
        component: () => import('/builds/big-dig-data/counter-validator/frontend/src/pages/public/[public_id].vue'),
        /* no children */
        meta: {
          "requiresAuth": false
        }
      }
    ],
  },
  {
    path: '/register',
    name: '/register',
    component: () => import('/builds/big-dig-data/counter-validator/frontend/src/pages/register.vue'),
    /* no children */
    meta: {
      "requiresAuth": false,
      "layout": "public"
    }
  },
  {
    path: '/reset-password',
    name: '/reset-password',
    component: () => import('/builds/big-dig-data/counter-validator/frontend/src/pages/reset-password.vue'),
    /* no children */
    meta: {
      "requiresAuth": false,
      "layout": "public"
    }
  },
  {
    path: '/settings',
    name: '/settings',
    component: () => import('/builds/big-dig-data/counter-validator/frontend/src/pages/settings.vue'),
    /* no children */
  },
  {
    path: '/stats',
    name: '/stats',
    component: () => import('/builds/big-dig-data/counter-validator/frontend/src/pages/stats.vue'),
    /* no children */
  },
  {
    path: '/validation',
    /* internal name: '/validation' */
    /* no component */
    children: [
      {
        path: '',
        name: '/validation/',
        component: () => import('/builds/big-dig-data/counter-validator/frontend/src/pages/validation/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/validation/[id]',
        component: () => import('/builds/big-dig-data/counter-validator/frontend/src/pages/validation/[id].vue'),
        /* no children */
      },
      {
        path: 'admin',
        name: '/validation/admin',
        component: () => import('/builds/big-dig-data/counter-validator/frontend/src/pages/validation/admin.vue'),
        /* no children */
      },
      {
        path: 'api',
        name: '/validation/api',
        component: () => import('/builds/big-dig-data/counter-validator/frontend/src/pages/validation/api.vue'),
        /* no children */
      },
      {
        path: 'file',
        name: '/validation/file',
        component: () => import('/builds/big-dig-data/counter-validator/frontend/src/pages/validation/file.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/verify-email',
    name: '/verify-email',
    component: () => import('/builds/big-dig-data/counter-validator/frontend/src/pages/verify-email.vue'),
    /* no children */
    meta: {
      "requiresAuth": false,
      "layout": "public"
    }
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

